import React from 'react'
import { Container,Row ,Col } from 'react-bootstrap'
import {motion} from 'framer-motion'

import ServiceData from '../assets/data/serviceData'

import './services.css'

const Services = () => {
    return (
        <section className='section__services'>
            <Container>
                <Row>
                    {ServiceData.map((item,index)=>{
                        return(
                            <Col key={index} lg='3' md='4'>
                                <motion.div whileHover={{scale:1.1}} className="service__item" style={{background:`${item.bg}`}}>
                                    <div>
                                        <i className={item.icon}></i>
                                    </div>
                                    <div>
                                        <h3>
                                            {item.title}
                                        </h3>
                                        <p>{item.subtitle}</p>
                                    </div>
                                </motion.div>
                            </Col>
                        )
                    })}
                    
                    
                </Row>
            </Container>
        </section>
    )
}

export default Services